export class DatastoreMissingModuleError extends Error {
  constructor(collection: string) {
    super(
      `Missing collection "${collection}".
        Check if you've imported Datastore${collection
          .charAt(0)
          .toUpperCase()}${collection.substr(
        1,
      )}Module in the parent module of any component that needs it.`,
    );
  }
}
